import { render } from "./Retributions.vue?vue&type=template&id=7473a926"
import script from "./Retributions.vue?vue&type=script&lang=js"
export * from "./Retributions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__